import { Outlet } from 'react-router-dom';

export const MainAppWrapper = () => {
    return <Outlet />;
};
